<template>
    <div class="row justify-content-center mt-5 two-tables">
        <template v-if="isBuilt">
            <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
                <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
            </div>
            <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
            <template v-if="missed_some_metric.length">
                <div class="missed-accounts my-3">There is an issue with the section below. The issue is likely caused by no metrics connected. Change the metrics/remove this section in the builder.</div>
            </template>
            <template v-else-if="!!missed_accounts.length">
                <div v-for="missed_account in missed_accounts" class="missed-accounts my-3">There are no accounts connected for {{missed_account}}. Either connect an account or change the metrics/remove this section in the builder.</div>
            </template>
            <div class="col-12 col-lg-6 d-flex flex-column justify-content-center">
                <h3 class="table-title text-uppercase mb-4">{{tableData.tables[1].table_name}}</h3>
                <div class="table-wrap flex-grow-1 p-3 left"
                     :class="{
                                'no-compare':!show_compare1,
                                'one-metric':tableData.metrics['table_1'].length==1,
                                'both-one-metric':tableData.metrics['table_1'].length==1 && tableData.metrics['table_2'].length==1,
                                'two-metrics':tableData.metrics['table_1'].length==2,
                                'three-metrics':tableData.metrics['table_1'].length==3,
                                'multiple':is_multiple1,
                                'advert':is_advert_sources1,
                                'social-media':is_social_media1,
                                'do_not_shorten_names':do_not_shorten_names,
                                'shorten_names':!do_not_shorten_names}">
                    <template v-if="tblData1.length && !reloading">
                        <v-client-table :data="tblData1" :columns="columns1" :options="options1">
                            <template v-for="(column, idx) in columns1" :slot="column" slot-scope="props">
                                <template v-if="show_arrow1 || show_percent_change1">
                                    <span v-if="!!props.row[column] && column.includes('seg')" :class="{'first-column':column.includes('seg1')}" :title="props.row[column]['title']">{{props.row[column]['value']}}</span>
                                    <template v-else>
                                        <template v-if="props.row[column]['sign'] == 'empty'">
                                            <span v-if="!!props.row[column]" class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                            <span v-if="!!props.row[column]" class="arrow-wrap" :class="[{'without-arrow':!show_arrow1}, 'column-'+idx]"><span class="arrow" :class="props.row[column]['sign']"></span>{{props.row[column]['perc']}}</span>
                                        </template>
                                        <template v-else>
                                            <span v-if="!!props.row[column]" class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                            <template v-if="show_percent_change1">
                                                <span v-if="!!props.row[column] && props.row[column]['sign']=='na'" class="arrow-wrap" :class="[{'without-arrow':!show_arrow1}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow1}]"></span>{{props.row[column]['perc']}}</span>
                                                <span v-if="!!props.row[column] && props.row[column]['sign']!='na'" class="arrow-wrap" :class="[{'without-arrow':!show_arrow1}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow1}]"></span>{{props.row[column]['perc']}}%</span>
                                            </template>
                                            <template v-else>
                                                <span v-if="!!props.row[column]" class="arrow-wrap" :class="[{'without-arrow':!show_arrow1}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow1}]"></span></span>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-if="!!props.row[column]">
                                        <span v-if="column.includes('seg')" :class="{'first-column':column.includes('seg1')}" :title="props.row[column]['title']">{{props.row[column]['value']}}</span>
                                        <span v-else :class="props.row">{{props.row[column]['value']}}</span>
                                    </template>
                                </template>
                            </template>
                        </v-client-table>
                        <div v-if="show_definitions1">
                            <ul>
                                <li v-for="(definition, key) in definitions1" class="definitions">
                                    <span class="definitions def1 key">{{key}}</span><p><span class="definitions def1 val">{{definition}}</span></p>
                                </li>
                            </ul>
                        </div>
                    </template>
                    <template v-else-if="is_index_comparison1">
                        <v-client-table :data="tblData1" :columns="columns1" :options="options1">
                            <template v-for="(column, idx) in columns1" :slot="column" slot-scope="props">
                                <template v-if="(show_arrow || show_percent_change) && !(column == 'metric')">
                                    <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                    <template v-if="props.row[column]['sign'] == 'na'">
                                        <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}</span>
                                        <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                    </template>
                                    <template v-else>
                                        <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}%</span>
                                        <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                    </template>
                                </template>
                                <span v-else>{{props.row[column]['value']}}</span>
                            </template>
                        </v-client-table>
                    </template>
                    <template v-else>
                        <div class="nodata-container p-5 text-center">
                            <div v-if="errors || missed_some_metric[1]" class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                            <div v-else class="empty-data"><img :src="$store.state.app_url+'/images/nodata.svg'"></div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="col-12 col-lg-6 d-flex flex-column justify-content-center">
                <h3 class="table-title text-uppercase mb-4 mt-4 mt-lg-0">{{tableData.tables[2].table_name}}</h3>
                <div class="table-wrap flex-grow-1 p-3 right"
                     :class="{
                            'no-compare':!show_compare2,
                            'one-metric':tableData.metrics['table_2'].length==1,
                            'both-one-metric':tableData.metrics['table_1'].length==1 && tableData.metrics['table_2'].length==1,
                            'two-metrics':tableData.metrics['table_2'].length==2,
                            'three-metrics':tableData.metrics['table_2'].length==3,
                            'multiple':is_multiple2,
                            'advert':is_advert_sources2,
                            'social-media':is_social_media2,
                            'do_not_shorten_names':do_not_shorten_names,
                            'shorten_names':!do_not_shorten_names}">
                    <template v-if="tblData2.length && !reloading">
                        <v-client-table :data="tblData2" :columns="columns2" :options="options2">
                            <template v-for="(column, idx) in columns2" :slot="column" slot-scope="props">
                                <template v-if="show_arrow2 || show_percent_change2">
                                    <span v-if="column.includes('seg')" :title="props.row[column]['title']">{{props.row[column]['value']}}</span>
                                    <template v-else>
                                        <template v-if="props.row[column]['sign'] == 'empty'">
                                            <span v-if="!!props.row[column]" class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                            <span v-if="!!props.row[column]" class="arrow-wrap" :class="'column-'+idx"><span class="arrow" :class="props.row[column]['sign']"></span>{{props.row[column]['perc']}}</span>
                                        </template>
                                        <template v-else>
                                            <span v-if="!!props.row[column]" class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                            <template v-if="show_percent_change2">
                                                <span v-if="!!props.row[column] && props.row[column]['sign']=='na'" class="arrow-wrap" :class="'column-'+idx"><span :class="[props.row[column]['sign'], {'arrow':show_arrow2}]"></span>{{props.row[column]['perc']}}</span>
                                                <span v-if="!!props.row[column] && props.row[column]['sign']!='na'" class="arrow-wrap" :class="'column-'+idx"><span :class="[props.row[column]['sign'], {'arrow':show_arrow2}]"></span>{{props.row[column]['perc']}}%</span>
                                            </template>
                                            <template v-else>
                                                <span v-if="!!props.row[column]" class="arrow-wrap" :class="'column-'+idx"><span :class="[props.row[column]['sign'], {'arrow':show_arrow2}]"></span></span>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    <span v-if="column.includes('seg')" :title="props.row[column]['title']">{{props.row[column]['value']}}</span>
                                    <span v-else :class="props.row">{{props.row[column]['value']}}</span>
                                </template>
                            </template>
                        </v-client-table>
                        <div v-if="show_definitions2">
                            <ul>
                                <li v-for="(definition, key) in definitions2" class="definitions">
                                    <span class="definitions def2 key">{{key}}</span><p><span class="definitions def2 val">{{definition}}</span></p>
                                </li>
                            </ul>
                        </div>
                    </template>
                    <template v-else-if="is_index_comparison2">
                        <v-client-table :data="tblData2" :columns="columns2" :options="options2">
                            <template v-for="(column, idx) in columns2" :slot="column" slot-scope="props">
                                <template v-if="(show_arrow || show_percent_change) && !(column == 'metric')">
                                    <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                    <template v-if="props.row[column]['sign'] == 'na'">
                                        <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}</span>
                                        <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                    </template>
                                    <template v-else>
                                        <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}%</span>
                                        <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                    </template>
                                </template>
                                <span v-else>{{props.row[column]['value']}}</span>
                            </template>
                        </v-client-table>
                    </template>
                    <template v-else>
                        <div class="nodata-container p-5 text-center">
                            <div v-if="errors || missed_some_metric[2]" class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                            <div v-else class="empty-data"><img :src="$store.state.app_url+'/images/nodata.svg'"></div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['isBuilt', 'hasSkb', 'tableData'],
        created() {
            if(this.isBuilt){
                this.num_rows = this.tableData.element_configurations.num_rows;
                this.show_index_values = this.tableData.element_configurations.show_index_values;
                this.index_name = this.show_index_values ? this.tableData.element_configurations.select_index_name : null;
                this.show_arrow1 = !!parseInt(this.tableData['tables'][1].reporting_table_type_configurations.show_change_arrows);
                this.show_arrow2 = !!parseInt(this.tableData['tables'][2].reporting_table_type_configurations.show_change_arrows);
                this.show_percent_change1 = !!parseInt(this.tableData['tables'][1].reporting_table_type_configurations.show_percentage_change);
                this.show_percent_change2 = !!parseInt(this.tableData['tables'][2].reporting_table_type_configurations.show_percentage_change);
                this.show_definitions1 = !!parseInt(this.tableData['tables'][1].reporting_table_type_configurations.show_definitions);
                this.show_definitions2 = !!parseInt(this.tableData['tables'][2].reporting_table_type_configurations.show_definitions);
                this.show_compare1 = this.show_arrow1 || this.show_percent_change1;
                this.show_compare2 = this.show_arrow2 || this.show_percent_change2;
                this.is_social_media1 = this.tableData.segments['table_1']['table_type'] == 'Social Media Advertising';
                this.is_social_media2 = this.tableData.segments['table_2']['table_type'] == 'Social Media Advertising';
                this.is_advert_sources1 = this.tableData.segments['table_1']['table_type'] == 'Advertising Sources';
                this.is_advert_sources2 = this.tableData.segments['table_2']['table_type'] == 'Advertising Sources';
                this.is_index_comparison1 = this.tableData.segments['table_1']['table_type'] == 'Index Comparison';
                this.is_index_comparison2 = this.tableData.segments['table_2']['table_type'] == 'Index Comparison';
                this.is_multiple1 = this.is_social_media1 || this.is_advert_sources1;
                this.is_multiple2 = this.is_social_media2 || this.is_advert_sources2;
                this.exclude_branded_terms1 = (this.tableData['tables'][1].table_type == 'Keywords') ? this.tableData['tables'][1].reporting_table_type_configurations.exclude_branded_terms : false;
                this.exclude_branded_terms2 = (this.tableData['tables'][2].table_type == 'Keywords') ? this.tableData['tables'][2].reporting_table_type_configurations.exclude_branded_terms : false;
                this.language_filter1 = (this.tableData['tables'][1].table_type == 'Keywords') ? this.tableData['tables'][1].reporting_table_type_configurations.language_filter : false;
                this.language_filter2 = (this.tableData['tables'][2].table_type == 'Keywords') ? this.tableData['tables'][2].reporting_table_type_configurations.language_filter : false;
                this.terms_to_include1 = (this.tableData['tables'][1].table_type == 'Keywords') ? this.tableData['tables'][1].reporting_table_type_configurations.terms_to_include : false;
                this.terms_to_include2 = (this.tableData['tables'][2].table_type == 'Keywords') ? this.tableData['tables'][2].reporting_table_type_configurations.terms_to_include : false;
                this.show_channel_groupings1 = (this.tableData['tables'][1].table_type == 'Campaigns') ? this.tableData['tables'][1].reporting_table_type_configurations.show_channel_groupings : false;
                this.show_channel_groupings2 = (this.tableData['tables'][2].table_type == 'Campaigns') ? this.tableData['tables'][2].reporting_table_type_configurations.show_channel_groupings : false;
                this.index_comparison1 = this.is_index_comparison1 ? this.tableData['tables'][1].reporting_table_type_configurations.index_comparison : null;
                this.index_comparison2 = this.is_index_comparison2 ? this.tableData['tables'][2].reporting_table_type_configurations.index_comparison : null;
                this.filter_element = this.tableData.element_configurations.filter_element;
                this.do_not_shorten_names = this.tableData.element_configurations.do_not_shorten_names;
                this.fetchServerData();
                this.missed_some_metric = this.checkMissedTables(this.tableData);
                this.missed_accounts = this.checkAccounts(this.tableData);
                event_bus.$on('current_dwm', () => {
                    this.current_dwm = this.$store.state.current_dwm;
                    event_bus.$emit('reloading', true);
                });
            }
        },
        mounted(){
            event_bus.$on('reloading', () => {
                this.reloading = true;
                this.fetchServerData();
            });
        },
        updated(){
            $('table.VueTables__table').each(function(idx, el){
                const table = $(el);
                for(let i=0;i<10;i++){
                    let max_w = 0;
                    table.find('span.value-with-additionals.column-'+i).each(function(i, e){
                        max_w = Math.max(max_w, parseInt($(e).width()));
                    });
                    table.find('span.value-with-additionals.column-'+i).width(max_w);
                    max_w = 0;
                    table.find('span.arrow-wrap.column-'+i).each(function(i, e){
                        max_w = Math.max(max_w, parseInt($(e).width()));
                    });
                    table.find('span.arrow-wrap.column-'+i).width(max_w*1.1);
                }
            });
        },
        data() {
            return {
                missed_accounts:[],
                missed_some_metric:[],
                isArchive:this.$store.state.isArchive,
                filter_element: null,
                do_not_shorten_names:false,
                columns1:[],
                columns2:[],
                options1:{
                    headings:{},
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    skin: 'table'
                },
                options2:{
                    headings:{},
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    skin: 'table'
                },
                tblData1:[],
                tblData2:[],
                num_rows:10,
                query:'',
                show_compare1:false,
                show_compare2:false,
                show_arrow1:false,
                show_arrow2:false,
                show_percent_change1:false,
                show_percent_change2:false,
                is_social_media1:false,
                is_social_media2:false,
                is_advert_sources1:false,
                is_advert_sources2:false,
                is_multiple1:false,
                is_multiple2:false,
                exclude_branded_terms1:false,
                exclude_branded_terms2:false,
                language_filter1:false,
                language_filter2:false,
                terms_to_include1:false,
                terms_to_include2:false,
                show_channel_groupings1:false,
                show_channel_groupings2:false,
                show_definitions1:false,
                show_definitions2:false,
                definitions1:null,
                definitions2:null,
                is_index_comparison1:false,
                is_index_comparison2:false,
                show_index_values:false,
                index_name:null,
                errors:false,
                showQueries:this.$store.state.showQueries,
                reloading:true
            }
        },
        methods: {
            fetchServerData(){
                const vueInstance = this;
                const params = {
                    'isArchive':this.isArchive,
                    'prefixed_id': this.isArchive ? this.tableData.archive_id : this.tableData.report_id,
                    'element_abbr':this.tableData.element_abbreviation,
                    'has_multiple_tables':true,
                    'dwm':this.$store.state.current_dwm,
                    'dates':this.$store.state.current_dates,
                    'element_id': this.tableData.element_id,
                    'prefixed_element_id': this.tableData.report_element_id,
                    'element_name':this.tableData.name,
                    'metrics': this.tableData.metrics,
                    'segments': this.tableData.segments,
                    'accounts': this.tableData.accounts,
                    'tables':this.tableData.tables,
                    'num_rows':this.num_rows,
                    'exclude_branded_terms1':this.exclude_branded_terms1,
                    'exclude_branded_terms2':this.exclude_branded_terms2,
                    'language_filter1':this.language_filter1,
                    'language_filter2':this.language_filter2,
                    'terms_to_include1':this.terms_to_include1,
                    'terms_to_include2':this.terms_to_include2,
                    'show_channel_groupings1':this.show_channel_groupings1,
                    'show_channel_groupings2':this.show_channel_groupings2,
                    'is_index_comparison1':this.is_index_comparison1,
                    'is_index_comparison2':this.is_index_comparison2,
                    'index_comparison1':this.index_comparison1,
                    'index_comparison2':this.index_comparison2,
                    'show_index_values': this.show_index_values,
                    'index_name':this.index_name,
                    'client_id':this.tableData.client_id,
                    'client_name':this.tableData.client_name,
                    'filter_element':this.filter_element,
                    'showQueries':this.showQueries,
                    'hasSkb':this.hasSkb,
                };

                axios.post('/api/reporting/element', params).then((response) => {
                    if(!!response.data && (typeof(response.data) == 'object')){
                        let data = response.data;
                        this.query = data.query;
                        this.errors = data['errors'];
                        if(!this.errors){
                            this.columns1 = _.has(data, 'table_1') ? data.table_1.columns : [];
                            this.columns2 = _.has(data, 'table_2') ? data.table_2.columns : [];
                            this.options1.headings = _.has(data, 'table_1') ? data.table_1.headings : [];
                            this.options2.headings = _.has(data, 'table_2') ? data.table_2.headings : [];
                            this.tblData1 = _.has(data, 'table_1') ? data.table_1.tblData : [];
                            this.tblData2 = _.has(data, 'table_2') ? data.table_2.tblData : [];
                        }
                        if(this.show_definitions1){
                            this.definitions1 = _.has(data, 'table_1') ? response.data.table_1.definitions : [];
                        }
                        if(this.show_definitions2){
                            this.definitions2 = _.has(data, 'table_2') ? response.data.table_2.definitions : [];
                        }
                    }

                    setTimeout(function(){
                        vueInstance.loaded1();
                        vueInstance.loaded2();
                    }, 200);

                    this.reloading = false;
                });
            },
            loaded1() {
                let maxWidth1 = 0;
                let maxWidth2 = 0;
                let maxWidth3 = 0;

                $('div.table-wrap.left').find('div.arrow-wrap.column-1').each(function(){
                    let itemWidth = $(this).outerWidth(true);
                    maxWidth1 = Math.max(maxWidth1, itemWidth);
                });
                $('div.table-wrap.left').find('div.arrow-wrap.column-2').each(function(){
                    let itemWidth = $(this).outerWidth(true);
                    maxWidth2 = Math.max(maxWidth2, itemWidth);
                });
                $('div.table-wrap.left').find('div.arrow-wrap.column-3').each(function(){
                    let itemWidth = $(this).outerWidth(true);
                    maxWidth3 = Math.max(maxWidth3, itemWidth);
                });
                $('div.table-wrap.left').find('div.arrow-wrap.column-1').outerWidth(maxWidth1);
                $('div.table-wrap.left').find('div.arrow-wrap.column-2').outerWidth(maxWidth2);
                $('div.table-wrap.left').find('div.arrow-wrap.column-3').outerWidth(maxWidth3);
            },
            loaded2() {
                let maxWidth1 = 0;
                let maxWidth2 = 0;
                let maxWidth3 = 0;

                $('div.table-wrap.right').find('div.arrow-wrap.column-1').each(function(){
                    let itemWidth = $(this).outerWidth(true);
                    maxWidth1 = Math.max(maxWidth1, itemWidth);
                });
                $('div.table-wrap.right').find('div.arrow-wrap.column-2').each(function(){
                    let itemWidth = $(this).outerWidth(true);
                    maxWidth2 = Math.max(maxWidth2, itemWidth);
                });
                $('div.table-wrap.right').find('div.arrow-wrap.column-3').each(function(){
                    let itemWidth = $(this).outerWidth(true);
                    maxWidth3 = Math.max(maxWidth3, itemWidth);
                });
                $('div.table-wrap.right').find('div.arrow-wrap.column-1').outerWidth(maxWidth1);
                $('div.table-wrap.right').find('div.arrow-wrap.column-2').outerWidth(maxWidth2);
                $('div.table-wrap.right').find('div.arrow-wrap.column-3').outerWidth(maxWidth3);
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div.two-tables{
        .VueTables__table {
            th, td {
                font-size: 1.44rem;
            }
        }
        .table{
            margin-bottom:0 !important;
        }
        div.table-wrap {
            border-radius: 2rem;
            &.shorten_names{
                .VueTables__table td{
                    overflow:hidden;
                    text-overflow:ellipsis;
                    @media screen and (min-width: 400px) {
                        max-width:200;
                    }
                    @media screen and (min-width: 1100px)  {
                        max-width:280;
                    }
                    @media screen and (min-width: 1380px) {
                        max-width:300;
                    }
                }
            }
            &.do_not_shorten_names{
                .VueTables__table td{
                    white-space:break-spaces !important;
                }
            }
            div.arrow-wrap{
                float:right;
                margin-top:0.2rem;
                font-size:0.75vw !important;
                @media screen and (max-width: 992px) {
                    font-size:1.8vw !important;
                }
            }
            span.value-with-additionals{
                display:inline-block;
                text-align:right;
            }
            span.arrow-wrap{
                font-size:0.625vw !important;
                @media screen and (max-width: 992px) {
                    font-size:1.8vw !important;
                }
                display:inline-block;
                text-align:left;
                &.without-arrow{
                    margin-left:0.5rem;
                }
            }
            span.arrow {
                font-size:0.5vw !important;
                position:relative;
                padding-left:1.5rem;
                &::before {
                    border-left: 0.6rem solid transparent;
                    border-right: 0.6rem solid transparent;
                    content: "";
                    display: inline-block;
                    height: 0;
                    width: 0;
                    position:absolute;
                    left:0;
                    top:0;
                }
                &.up{
                    &::before {
                        border-bottom: 0.5rem dashed white;
                    }
                }
                &.down{
                    &::before {
                        border-top: 0.5rem dashed white;
                    }
                }
            }
            thead th{
                border-bottom:none;
                color:white;
                text-transform:uppercase;
                &:nth-child(n+2){
                    text-align:center;
                }
                padding-left:0.2rem;
                padding-right:0.2rem;
            }
            tbody tr {
                line-height:1.5;
                color:white;
                td{
                    font-size:1vw !important;
                    @media screen and (max-width: 992px) {
                        font-size: 2vw !important;
                    }
                    white-space:nowrap;
                    &:nth-child(2n+2){
                        text-align:center;
                    }
                }
            }
            &.left {
                background-color:$gold;
                tbody tr {
                    border-bottom: 1px solid $light-gold;
                    td:nth-child(n+3){
                        border-left:1px solid $light-gold;
                    }
                    &:last-child{
                        border-bottom:none;
                    }
                }
            }
            &.right{
                background-color:$black-blue;
                tbody tr {
                    border-bottom: 1px solid $light-blue;
                    td:nth-child(n+3){
                        border-left:1px solid $light-blue;
                    }
                    &:last-child{
                        border-bottom:none;
                    }
                }
            }
            &.both-one-metric.shorten_names{
                .VueTables__table td{
                    @media screen and (min-width: 400px) {
                        max-width:100;
                    }
                    @media screen and (min-width: 1100px) {
                        max-width:140;
                    }
                    @media screen and (min-width: 1380px) {
                        max-width:150;
                    }
                }
            }
            &.one-metric:not(.multiple){
                tbody tr {
                    td:nth-child(n+3){
                        border-left:none;
                    }
                    td:nth-child(2n+2){
                        padding-left:0;
                        padding-right:0.2rem;
                    }
                }
                &.left {
                    tbody tr {
                        td:nth-child(4n+3){
                            border-left:1px solid $light-gold;
                        }
                    }
                }
                &.right{
                    tbody tr {
                        td:nth-child(4n+3){
                            border-left:1px solid $light-blue;
                        }
                    }
                }
            }
            &.two-metrics, &.three-metrics{
                tbody tr {
                    td{
                        &:nth-child(3){
                            text-align:center;
                        }
                    }
                }
            }
            &.multiple{
                tbody tr {
                    td:nth-child(n+3){
                        border-left:none;
                    }
                    td:nth-child(2n+2){
                        padding-left:0;
                        padding-right:0.2rem;
                    }
                    td:nth-child(1){
                        word-break: break-word;
                    }
                }
                &.social-media{
                    tbody tr {
                        td:nth-child(1), td:nth-child(2), td:nth-child(3){
                            text-align:left;
                        }
                    }
                    thead tr{
                        th:nth-child(1), th:nth-child(2), th:nth-child(3){
                            text-align:left;
                        }
                    }
                }
                &.advert{
                    tbody tr {
                        td:nth-child(1), td:nth-child(2){
                            text-align:left;
                        }
                    }
                    thead tr{
                        th:nth-child(1), th:nth-child(2){
                            text-align:left;
                        }
                    }
                }
                &.left:not(.advert) {
                    tbody tr {
                        td:nth-child(n+4){
                            border-left:1px solid $light-gold;
                            padding-left:0.5rem;
                        }
                    }
                }
                &.right:not(.advert){
                    tbody tr {
                        td:nth-child(n+4){
                            border-left:1px solid $light-blue;
                            padding-left:0.5rem;
                        }
                    }
                }
                &.left.advert {
                    tbody tr {
                        td:nth-child(n+3){
                            border-left:1px solid $light-gold;
                            padding-left:0.5rem;
                        }
                    }
                }
                &.right.advert{
                    tbody tr {
                        td:nth-child(n+3){
                            border-left:1px solid $light-blue;
                            padding-left:0.5rem;
                        }
                    }
                }
                span.first-column{
                    white-space:nowrap !important;
                }
                div.table-responsive{
                    overflow:hidden;
                    position:relative;
                }
                tbody tr {
                    td{
                        span{
                            display:inline-block;
                            white-space:nowrap !important;
                            max-width: 14rem !important;
                            text-overflow: ellipsis;
                            overflow:hidden;
                        }
                    }
                }
            }
        }
        li.definitions{
            span.definitions{
                font-size:1.2rem;
                &.def1{
                    &.key{
                        color:$light-gold;
                        white-space:nowrap;
                    }
                    &.val{
                        color:white;
                    }
                }
                &.def2{
                    &.key{
                        color:$light-blue;
                        white-space:nowrap;
                    }
                    &.val{
                        color:white;
                    }
                }
            }
            p{
                margin-bottom:0 !important;
            }
            &::marker{
                color:white;
            }
        }
    }
</style>
